module.exports = __webpack_public_path__ + "img/1009.bc38ccd9.png";